import { useMutation, useQuery } from "@tanstack/react-query";
import {
  createSubCategory,
  getDefaultCategory,
  updateSubCategory,
} from "~/services/category.service";

export function useCreateCategoryMutation() {
  return useMutation((payloads) => createSubCategory(payloads));
}
export function useUpdateCategoryMutation() {
  return useMutation((payloads) => updateSubCategory(payloads));
}

export function useParentCategoryQuery() {
  return useQuery({
    queryFn: () => getDefaultCategory(),
    queryKey: ["parentCatData"],
  });
}
